@if (map$ | async; as map) {
    <div class="map" data-test="map-view">
        @if (map.centralPathRowSets.length) {
            <cdk-virtual-scroll-viewport #viewport itemSize="60" class="map__viewport">
                <div
                    *cdkVirtualFor="
                        let centralPathRowSet of map.centralPathRowSets;
                        index as i;
                        templateCacheSize: 0
                    "
                    class="row-set"
                >
                    @if (map | mapRowPosition: 'left') {
                        <div class="row-set__row row-set__row--left">
                            <app-map-row
                                app-ios-contextmenu
                                [activityNumber]="activity().number"
                                [row]="centralPathRowSet.left"
                                data-test="map-row-left"
                            />
                        </div>
                    }
                    @if (map | mapRowPosition: 'right') {
                        <div class="row-set__row row-set__row--right">
                            <app-map-row
                                app-ios-contextmenu
                                [activityNumber]="activity().number"
                                [row]="centralPathRowSet.right"
                                data-test="map-row-right"
                            />
                        </div>
                    }
                </div>
            </cdk-virtual-scroll-viewport>
        }
    </div>
} @else {
    <priva-notification status="Info">{{
        'ERROR.TITLE.NO_GREENHOUSE_SELECTED' | translate
    }}</priva-notification>
}
